// ============================================================
// src/utils/api.js — API helper with per-hospital JWT support
// ✅ Reads token from correct hospital key
// ============================================================
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// ✅ Get token for current hospital from URL slug
const getToken = () => {
  // Try to get slug from current URL path
  // e.g. /hospital/sai-dental-hospital → slug = sai-dental-hospital
  const path = window.location.pathname;
  const match = path.match(/\/hospital\/([^/]+)/);
  const slug = match ? match[1] : null;

  if (slug) {
    // Hospital page — use hospital-specific token
    const hospitalToken = localStorage.getItem(`pearlsmile_token_${slug}`);
    if (hospitalToken) return hospitalToken;
  }

  // Default PearlSmile token (direct /pearlsmile route or root)
  return localStorage.getItem("pearlsmile_token");
};

const headers = (extra = {}) => ({
  "Content-Type": "application/json",
  ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
  ...extra,
});

const api = {
  get: async (path) => {
    const res = await fetch(`${BASE_URL}${path}`, { headers: headers() });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: "Request failed" }));
      throw new Error(err.message || "Request failed");
    }
    return res.json();
  },
  post: async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: "POST",
      headers: headers(),
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: "Request failed" }));
      throw new Error(err.message || "Request failed");
    }
    return res.json();
  },
  put: async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: "PUT",
      headers: headers(),
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: "Request failed" }));
      throw new Error(err.message || "Request failed");
    }
    return res.json();
  },
  patch: async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: "PATCH",
      headers: headers(),
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: "Request failed" }));
      throw new Error(err.message || "Request failed");
    }
    return res.json();
  },
  delete: async (path) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: "DELETE",
      headers: headers(),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: "Request failed" }));
      throw new Error(err.message || "Request failed");
    }
    return res.json();
  },
};

export default api;
